import { EnvironmentProviders, importProvidersFrom } from '@angular/core';

import { SharedServicesModule } from './shared-services.module';

/**
 * Standalone provider function that replaces direct use of
 * `importProvidersFrom(SharedServicesModule)` in application code.
 *
 * Exposes the same DI providers that `SharedServicesModule` registers (HTTP client,
 * ACA core/UI/datetime services, `ServerReceiveService` initialisation) as an
 * `EnvironmentProviders` token that is safe to use in standalone route configs and
 * `bootstrapApplication` calls, satisfying PR Compliance ID 165.
 *
 * The `NgModule` coupling is encapsulated here inside the library; application code
 * references only this function and never imports `SharedServicesModule` directly.
 *
 * @returns `EnvironmentProviders` containing all providers from `SharedServicesModule`
 *          and its transitively imported modules.
 */
export function provideSharedServices(): EnvironmentProviders {
  return importProvidersFrom(SharedServicesModule);
}
